import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Resolve image URLs: uploaded files come back as "/api/files/..." (relative), defaults are absolute.
export const imgUrl = (url) => {
  if (!url) return url;
  return url.startsWith("/api") ? `${BACKEND_URL}${url}` : url;
};
